import BlogCards from "@/Components/DataDisplayCompoants/BlogCard";
import BlueCards from "@/Components/DataDisplayCompoants/BlueCard";
import GreenCards from "@/Components/DataDisplayCompoants/GreenCard";
import Section from "@/Components/LayoutComponents/Section";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useEffect, useState } from "react";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";
const componentsMap = {
  blog: BlogCards,
  blue: BlueCards,
  green: GreenCards,
};
type ComponentKey = keyof typeof componentsMap;
interface ThankYouBlogsProps {
  block: any;
}
const ThankYouBlogs: React.FC<ThankYouBlogsProps> = ({ block }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    loop: true,
    slides: {
      perView: 1.1,
      origin: "center",
      spacing: 15,
    },
    breakpoints: {
      "(max-width: 1024px)": {
        slides: {
          perView: 1.5,
          origin: "center",
          spacing: 15,
        },
      },
      "(max-width: 500px)": {
        slides: {
          perView: 1.2,
          origin: "center",
          spacing: 15,
        },
      },
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  useEffect(() => {
    const slider = instanceRef.current;
    if (!slider) return;

    const interval = setInterval(() => {
      if (slider) {
        slider.next();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [instanceRef]);

  return (
    <Section>
      <div className="container">
        <div className="hidden md:grid grid-cols-3 gap-[30px]">
            {block?.cards?.map((card: any, index: number) => {
              const Component = componentsMap[card.varient as ComponentKey];
              if (!Component) return null;

              if (card.varient === "blog" && index === 0) {
                return (
                  <div key={index} className="xl:col-span-2 col-span-6">
                    <Component
                      imageUrl={
                        card.image
                          ? `${baseUrl}${card.image.data.attributes.url}`
                          : "/images/blog-card.jpg"
                      }
                      label={card.link?.label}
                      title={card.title}
                      link={card.link.href}
                      details={card.description}
                      classname="h-full ipad-services"
                    />
                  </div>
                );
              }

              if (card.varient === "blue") {
                return (
                  <div
                    key={index}
                    className="relative xl:col-span-1  col-span-6"
                  >
                    <Component
                      imageUrl="/images/Blue_Vector.png"
                      label={card.link?.label}
                      link={card.link.href}
                      title={card.title}
                      details={card.description}
                      classname="bg-new-image ipad-services"
                    />
                  </div>
                );
              }

              if (card.varient === "green") {
                return (
                  <div
                    key={index}
                    className="relative xl:col-span-1  col-span-6"
                  >
                    <Component
                      imageUrl={"/images/Green_Vector.png"}
                      label={card.link?.label}
                      link={card.link.href}
                      title={card.title}
                      classname="bg-new-image ipad-services"
                      details={card.description}
                    />
                  </div>
                );
              }

              if (card.varient === "blog" && index === 3) {
                return (
                  <div key={index} className="xl:col-span-2 col-span-6">
                    <Component
                      imageUrl={
                        card.image
                          ? `${baseUrl}${card.image.data.attributes.url}`
                          : "/images/blog-card.jpg"
                      }
                      label={card.link?.label}
                      title={card.title}
                      link={card.link.href}
                      classname="h-full ipad-services"
                      details={card.description}
                    />
                  </div>
                );
              }

              return null;
            })}
        </div>
        <div className="md:hidden">
          <div ref={sliderRef} className="keen-slider">
            {block?.cards?.map((card: any, index: number) => {
              const Component = componentsMap[card.varient as ComponentKey];
              if (!Component) return null;

              return (
                <div key={index} className="keen-slider__slide">
                  <Component
                    imageUrl={
                      card.image
                        ? `${baseUrl}${card.image.data?.attributes?.url}`
                        : "/images/blog-card.jpg"
                    }
                    label={card.link?.label}
                    link={card.link.href}
                    title={card.title}
                    classname="h-full ipad-services"
                    details={card.description}
                  />
                </div>
              );
            })}
          </div>
          <div className="block bg-white min-w-[224px] max-w-[224px] mx-auto mt-[24px] ">
            {loaded && instanceRef.current && (
              <div className="dots container p-0">
                {Array.from({
                  length:
                    instanceRef?.current?.track?.details?.slides?.length,
                }).map((_, idx) => (
                  <button
                    aria-label="dot"
                    key={idx}
                    onClick={() => instanceRef.current?.moveToIdx(idx)}
                    className={`dot${currentSlide === idx ? " active" : ""}`}
                  >
                    <span
                      className={currentSlide === idx ? "active" : ""}
                    ></span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default ThankYouBlogs;
